"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleFavorite = exports.createCollectionPreview = exports.CollectionPreviewV1 = void 0;
var CollectionPreviewV1 = /** @class */ (function () {
    function CollectionPreviewV1(props) {
        this.image = null;
        this.processing = false;
        this.id = props.id;
        this.slug = props.slug;
        this.url = props.url;
        this.setImage(props.image_url);
        this.lang = props.lang;
        this.title = props.title;
        this.editorName = props.editorName;
        this.previewText = props.previewText;
        this.topics = props.topics;
        this.createdAt = props.createdAt;
        this.favorited = props.favorited;
        this.articles = props.articles;
        this.videos = props.videos;
        this.audios = props.audios;
    }
    CollectionPreviewV1.prototype.setImage = function (url) {
        if (url === null) {
            this.image = null;
            return;
        }
        this.image = { url: url, loaded: false };
    };
    return CollectionPreviewV1;
}());
exports.CollectionPreviewV1 = CollectionPreviewV1;
function createCollectionPreview(rawPreview) {
    return new CollectionPreviewV1({
        id: rawPreview.id,
        slug: rawPreview.slug,
        url: rawPreview.web_url,
        lang: rawPreview.lang,
        title: rawPreview.title,
        editorName: rawPreview.editor_name,
        previewText: rawPreview.preview_text,
        topics: rawPreview.topics,
        image_url: rawPreview.cover_image_url,
        createdAt: new Date(rawPreview.created_at),
        favorited: rawPreview.favorited,
        articles: rawPreview.articles,
        videos: rawPreview.videos,
        audios: rawPreview.audios,
    });
}
exports.createCollectionPreview = createCollectionPreview;
function toggleFavorite(preview, http) {
    return http.get('local/api/collections/set-favorite/' + preview.id)
        .then(function (res) {
        if (res.data.result === 'added') {
            return {
                favorited: true,
            };
        }
        if (res.data.result === 'removed') {
            return {
                favorited: false,
            };
        }
        throw new Error('Could not toggle favorite.');
    });
}
exports.toggleFavorite = toggleFavorite;
